function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .tut_1 {\r\n\t\tfill: none;\r\n        stroke: #37d7a0;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .tut_2 {\r\n        fill: #37d7a0;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "TuTorial",
  transform: "translate(-1132.587 -68.268)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  className: "tut_1",
  d: "M1.136,2.02,8.921,0a.643.643,0,0,1,.637.649v9.742a.643.643,0,0,1-.637.649L1.136,9.02a1.4,1.4,0,0,1-.981-1v-5A1.4,1.4,0,0,1,1.136,2.02Z",
  transform: "translate(1154.029 72.268)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  className: "tut_1",
  d: "M2.954,0H19.643A2.005,2.005,0,0,1,21.6,2.053V15.947A2.005,2.005,0,0,1,19.643,18H2.954A2.005,2.005,0,0,1,1,15.947V2.053A2.005,2.005,0,0,1,2.954,0Z",
  transform: "translate(1132.587 69.268)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_55",
  "data-name": "Ellipse 55",
  className: "tut_2",
  cx: 1.962,
  cy: 1.962,
  r: 1.962,
  transform: "translate(1147.318 72.268)"
}));

var SvgSideVideo = function SvgSideVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-video.e39f87e7.svg";
export { ForwardRef as ReactComponent };